import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C11ReverseRowStoryWithVisualProps = RenderingProps<
  C11ReverseRowStoryWithVisualFields,
  RenderingParams
>;

export type RenderingParams = {
  ImageSide?: string;
  HeadlineTag?: string;
  CTAStyle?: string;
  ContentVerticalAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;

export type C11ReverseRowStoryWithVisualFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
  Image?: ImageField;
  VideoID?: Field<string>;
};
